<div class="layout-col full">
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [cleanUp]="true"
    [selectionVisible]="true"
    [selectionMultiEnabled]="false"
    [interactionMode]="'selection'"
    (selectionSingleChange)="onSingleSelection($event)"
  >
    <!-- icon Column -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 30px" mat-sort-header="type"></th>
      <td
        mat-cell
        *matCellDef="let node"
        [matTooltip]="
          node.path + ' (' + ('shopfloor.storage.nodes.type.' + node.type | translate) + ')'
        "
      >
        @if (node.type === StorageNodeType.Logical) {
          <mat-icon>border_clear</mat-icon>
        }
        @if (node.type === StorageNodeType.Physical) {
          <mat-icon>border_all</mat-icon>
        }
      </td>
    </ng-container>

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let node">{{ node.number }}</td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let node">{{ node.description }}</td>
    </ng-container>

    <!-- priority Column -->
    <ng-container matColumnDef="priority">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.priority' | translate }}
      </th>
      <td mat-cell *matCellDef="let node">{{ node.priority }}</td>
    </ng-container>

    <!-- facility Column -->
    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.facility' | translate }}
      </th>
      <td mat-cell *matCellDef="let node">{{ node.facility }}</td>
    </ng-container>
  </elder-table>
</div>
